if (!customElements.get('mobile-reels')) customElements.define('mobile-reels', class extends HTMLElement {
  connectedCallback() {
    this.v = this.querySelector('[data-reels-viewer]');
    this.f = this.querySelector('[data-reels-feed]');
    this.s = [...this.querySelectorAll('[data-reel]')];
    this.entry = this.querySelector('[data-reels-open]');
    this.p = new Map();
    this.i = 0;
    this.m = false;
    this.raf = 0;
    this.ctrl = new AbortController();
    const options = { signal: this.ctrl.signal };
    this.entry?.addEventListener('click', () => this.v.hidden ? this.open() : this.close(), options);
    this.entry?.setAttribute('aria-expanded', 'false');
    this.querySelector('[data-reels-close]')?.addEventListener('click', () => this.close(), options);
    this.querySelector('[data-reels-play]')?.addEventListener('click', () => this.toggle(), options);
    this.querySelector('[data-reels-mute]')?.addEventListener('click', () => this.mute(), options);
    this.querySelector('[data-reels-fallback]')?.addEventListener('click', () => this.play(), options);
    this.f?.addEventListener('scroll', () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const index = Math.max(0, Math.min(this.s.length - 1, Math.round(this.f.scrollTop / this.f.clientHeight)));
        if (index !== this.i) this.activate(index);
      }, 80);
    }, options);
    this.v?.addEventListener('click', event => this.productAction(event), options);
    this.v?.addEventListener('click', event => {
      if (!event.target.closest('button,a,.uoozee-mobile-reels__product-card,.uoozee-mobile-reels__sheet')) this.toggle();
    }, options);
    this.v?.addEventListener('contextmenu', event => event.preventDefault(), options);
    this.v?.addEventListener('dragstart', event => event.preventDefault(), options);
    this.key = event => {
      if (this.sizeDialog?.open) return;
      if (this.navigationOpen()) return;
      if (event.key === 'Escape') this.closeProductSheet() || this.close();
      if (event.key === 'ArrowDown') this.go(1);
      if (event.key === 'ArrowUp') this.go(-1);
      if (event.key === 'Tab') this.trap(event);
    };
    this.visibility = () => document.hidden ? this.pause() : !this.v.hidden && this.play();
    this.mountEntry();
    this.navigationObserver = new MutationObserver(() => {
      if (this.v.hidden) return;
      if (this.navigationOpen()) {
        this.resumeAfterNavigation ||= !!this.p.get(this.i) && !this.p.get(this.i).paused;
        this.pause();
      } else if (this.resumeAfterNavigation) {
        this.resumeAfterNavigation = false;
        if (!document.hidden) this.play();
      }
    });
    document.querySelectorAll('.side-panel,.mobile-toggle-wrapper').forEach(element =>
      this.navigationObserver.observe(element, { attributes: true, attributeFilter: ['class', 'open'] }));
    this.navigationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.ui();
  }

  disconnectedCallback() { this.ctrl?.abort(); this.navigationObserver?.disconnect(); this.close(false); this.unmountEntry(); }
  navigationOpen() { return document.body.classList.contains('picky-cart-opened') || !!document.querySelector('.side-panel.active,.mobile-toggle-wrapper[open]'); }
  mountEntry() {
    const logo = document.querySelector('.header .logolink');
    if (!logo || !this.entry || logo.closest('.uoozee-reels-header-group')) return;
    const group = document.createElement('div');
    group.className = 'uoozee-reels-header-group';
    logo.before(group); group.append(logo, this.entry);
    this.logo = logo; this.headerGroup = group;
    this.header = logo.closest('.section-header-section');
    this.logoCurrent = logo.getAttribute('aria-current');
    logo.addEventListener('click', event => {
      if (!matchMedia('(max-width:749px)').matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      // On the home page, switch views without a reload. Elsewhere keep the home link.
      if (!this.isHomeView()) return;
      event.preventDefault();
      if (!this.v.hidden) this.close(false);
      logo.focus({ preventScroll: true });
    }, { signal: this.ctrl.signal });
    this.syncNavigation();
  }
  isHomeView() {
    return this.logo && new URL(this.logo.href, location.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '');
  }
  syncNavigation() {
    if (!this.logo) return;
    if (this.v.hidden && this.isHomeView()) this.logo.setAttribute('aria-current', 'page');
    else this.logo.removeAttribute('aria-current');
  }
  unmountEntry() {
    if (!this.headerGroup || !this.logo) return;
    if (this.logoCurrent === null) this.logo.removeAttribute('aria-current');
    else this.logo.setAttribute('aria-current', this.logoCurrent);
    this.headerGroup.before(this.logo); this.entry?.remove(); this.headerGroup.remove();
  }
  async open() {
    if (!this.s.length) return;
    this.event('reels_button_click', { button_location: 'header' });
    this.y = scrollY; this.last = document.activeElement;
    document.documentElement.classList.add('uoozee-reels-open');
    document.body.style.top = `-${this.y}px`;
    this.v.hidden = false; this.v.setAttribute('aria-hidden', 'false');
    this.entry?.setAttribute('aria-expanded', 'true');
    this.syncNavigation();
    if (this.header?.id) this.v.setAttribute('aria-owns', this.header.id);
    document.addEventListener('keydown', this.key);
    document.addEventListener('visibilitychange', this.visibility);
    (this.entry || this.querySelector('[data-reels-close]')).focus({ preventScroll: true });
    await this.activate(0);
  }
  close(focus = true) {
    if (!this.v) return;
    if (!this.v.hidden) this.event('reels_close');
    this.closeProductSheet(false); this.release();
    this.v.hidden = true; this.v.setAttribute('aria-hidden', 'true');
    this.v.removeAttribute('aria-owns');
    this.entry?.setAttribute('aria-expanded', 'false');
    this.syncNavigation();
    this.resumeAfterNavigation = false;
    document.documentElement.classList.remove('uoozee-reels-open');
    document.body.style.top = ''; scrollTo(0, this.y || 0);
    document.removeEventListener('keydown', this.key);
    document.removeEventListener('visibilitychange', this.visibility);
    if (focus) this.last?.focus();
  }
  make(index, preload) {
    if (this.p.has(index)) return this.p.get(index);
    const slide = this.s[index], video = document.createElement('video');
    video.className = 'uoozee-mobile-reels__video'; video.src = slide.dataset.videoSrc; video.preload = preload;
    video.playsInline = true; video.muted = this.m; video.loop = true; video.controls = false;
    video.controlsList = 'nodownload noremoteplayback'; video.disablePictureInPicture = true; video.disableRemotePlayback = true;
    video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
    video.setAttribute('controlslist', 'nodownload noremoteplayback'); video.setAttribute('disablepictureinpicture', ''); video.setAttribute('disableremoteplayback', '');
    video.addEventListener('playing', () => {
      if (index !== this.i) return;
      slide.classList.add('is-playing'); this.querySelector('[data-reels-fallback]').hidden = true;
      this.progress(); this.event('reel_play');
    });
    video.addEventListener('error', () => { if (index === this.i) this.querySelector('[data-reels-error]').hidden = false; });
    slide.querySelector('[data-reel-media]').append(video); this.p.set(index, video); return video;
  }
  async activate(index) {
    this.closeProductSheet(false); this.i = (index + this.s.length) % this.s.length; this.pause();
    const keep = new Set([this.i, (this.i + 1) % this.s.length, (this.i - 1 + this.s.length) % this.s.length]);
    keep.forEach(item => this.make(item, item === this.i ? 'auto' : 'metadata'));
    this.p.forEach((video, item) => { if (!keep.has(item)) { video.removeAttribute('src'); video.load(); video.remove(); this.p.delete(item); } });
    this.s.forEach((slide, item) => slide.classList.toggle('is-active', item === this.i));
    this.querySelector('[data-reels-progress]').style.width = '0'; this.querySelector('[data-reels-error]').hidden = true;
    this.event('reel_impression');
    await this.play();
  }
  go(direction) {
    const next = (this.i + direction + this.s.length) % this.s.length;
    this.s[next].scrollIntoView({ behavior: Math.abs(next - this.i) > 1 ? 'auto' : 'smooth', block: 'start' });
  }
  async play() {
    if (document.hidden || this.v.hidden || this.navigationOpen()) return;
    const video = this.make(this.i, 'auto'); video.muted = this.m;
    try { await video.play(); this.querySelector('[data-reels-fallback]').hidden = true; }
    catch (error) { this.querySelector('[data-reels-fallback]').hidden = false; }
    this.ui();
  }
  pause() { this.p.forEach(video => video.pause()); cancelAnimationFrame(this.raf); }
  toggle() { const video = this.p.get(this.i); video?.paused ? this.play() : (video?.pause(), cancelAnimationFrame(this.raf)); this.ui(); }
  mute() {
    this.m = !this.m; this.p.forEach(video => video.muted = this.m); this.ui();
    this.querySelector('[data-reels-mute]')?.setAttribute('aria-label', this.m ? 'Turn sound on' : 'Mute video');
    this.event('reels_sound_toggle', { sound_enabled: !this.m });
  }
  ui() {
    const video = this.p.get(this.i);
    this.querySelector('[data-reels-play]').textContent = video?.paused ? '▶' : 'Ⅱ';
    this.querySelector('[data-reels-mute]').textContent = this.m ? '⌁' : '♪';
  }
  progress() {
    cancelAnimationFrame(this.raf);
    const tick = () => { const video = this.p.get(this.i); if (!video || video.paused) return; if (Number.isFinite(video.duration)) this.querySelector('[data-reels-progress]').style.width = `${video.currentTime / video.duration * 100}%`; this.raf = requestAnimationFrame(tick); };
    tick();
  }
  release() { this.pause(); this.p.forEach(video => { video.removeAttribute('src'); video.load(); video.remove(); }); this.p.clear(); this.s?.forEach(slide => slide.classList.remove('is-playing')); }
  trap(event) {
    const selector = 'button:not([hidden]),a[href],summary';
    const items = [...(this.header?.querySelectorAll(selector) || []), ...this.v.querySelectorAll(selector)]
      .filter(element => element.offsetParent !== null && getComputedStyle(element).visibility !== 'hidden');
    if (!items.length) return; const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  productAction(event) {
    const size = event.target.closest('[data-reels-size-open]');
    if (size) { event.preventDefault(); this.openSizeChart(size); return; }
    const open = event.target.closest('[data-reels-product-open]');
    const close = event.target.closest('[data-reels-product-close]');
    const value = event.target.closest('[data-reels-option-value]');
    const add = event.target.closest('[data-reels-add]');
    if (open) { const sheet = open.closest('[data-reel]').querySelector('[data-reels-product-sheet]'); sheet.hidden = false; this.hydrateSheet(sheet); this.event('reels_product_click', { click_type: 'inline_sheet' }); return; }
    if (close) { this.closeProductSheet(); return; }
    if (value) { const group = value.closest('[data-reels-option]'); group.querySelectorAll('[data-reels-option-value]').forEach(item => item.classList.toggle('is-selected', item === value)); this.updateVariant(value.closest('[data-reels-product-sheet]')); return; }
    if (add) this.addToCart(add);
  }
  closeProductSheet() {
    this.closeSizeChart(false);
    const sheet = this.querySelector('[data-reels-product-sheet]:not([hidden])');
    if (!sheet) return false; sheet.hidden = true; return true;
  }
  hydrateSheet(sheet) {
    if (sheet.dataset.ready) return;
    const variants = JSON.parse(sheet.querySelector('[data-reels-variants]').textContent); sheet._variants = variants;
    sheet._prices = JSON.parse(sheet.querySelector('[data-reels-prices]')?.textContent || '{}');
    sheet.querySelectorAll('[data-reels-option-value]').forEach(button => {
      const group = button.closest('[data-reels-option]');
      const index = Number(group.dataset.optionIndex);
      // A variant image represents color/type, not size. Never hide size labels.
      if (index !== 0 || group.dataset.optionPresentation !== 'image') return;
      const variant = variants.find(item => item.options[index] === button.dataset.value && item.featured_image);
      if (variant?.featured_image?.src) { button.style.setProperty('--option-image', `url(${variant.featured_image.src})`); button.classList.add('has-image'); }
    });
    sheet.dataset.ready = 'true'; this.updateVariant(sheet);
  }
  ensureSizeDialog() {
    if (this.sizeDialog) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'uoozee-mobile-reels__size-chart';
    dialog.setAttribute('aria-label', 'Size Chart');
    dialog.innerHTML = '<div class="uoozee-mobile-reels__size-heading"><h2>Size Chart</h2><button type="button" data-size-close aria-label="Close size chart" autofocus>&times;</button></div><p data-size-product></p><div class="uoozee-mobile-reels__size-units" data-size-units hidden role="group" aria-label="Measurement unit"><button type="button" data-size-unit="cm" aria-pressed="true">CM</button><button type="button" data-size-unit="inch" aria-pressed="false">INCH</button></div><p data-size-status role="status"></p><div class="uoozee-mobile-reels__size-tables" data-size-tables tabindex="0" role="region" aria-label="Product measurements"></div><button type="button" data-size-retry hidden>Try again</button>';
    dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeSizeChart(); });
    dialog.addEventListener('click', event => {
      event.stopPropagation();
      const rect = dialog.getBoundingClientRect();
      const outside = event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
      if (outside || event.target.closest('[data-size-close]')) this.closeSizeChart();
      const unit = event.target.closest('[data-size-unit]');
      if (unit) this.renderSizeTables(unit.dataset.sizeUnit);
      if (event.target.closest('[data-size-retry]')) this.openSizeChart(this.sizeTrigger);
    });
    this.v.append(dialog); this.sizeDialog = dialog;
    this.sizeCharts = new Map();
  }
  async openSizeChart(trigger) {
    this.ensureSizeDialog();
    this.sizeTrigger = trigger;
    const dialog = this.sizeDialog, slide = trigger.closest('[data-reel]');
    const request = this.sizeRequest = (this.sizeRequest || 0) + 1;
    dialog.querySelector('[data-size-product]').hidden = true;
    if (!dialog.querySelector('[data-size-note]')) {
      const note = document.createElement('p');
      note.setAttribute('data-size-note', '');
      note.append('1 inch = 2.54 cm', document.createElement('br'), document.createElement('br'), "Please consult the size chart we provide for this item's measurements to help you decide which size to buy. Please note: there may be a 1\u20133 cm difference due to manual measurement.");
      dialog.querySelector('[data-size-tables]').after(note);
    }
    dialog.querySelector('[data-size-note]').hidden = true;
    dialog.querySelector('[data-size-status]').hidden = false;
    dialog.querySelector('[data-size-tables]').replaceChildren();
    dialog.querySelector('[data-size-status]').textContent = 'Loading size chart...';
    dialog.querySelector('[data-size-units]').hidden = true;
    dialog.querySelector('[data-size-retry]').hidden = true;
    if (!dialog.open) dialog.showModal();
    try {
      const guide = JSON.parse(trigger.dataset.sizeGuide || 'null');
      const rows = Array.isArray(guide) ? guide.map(row => String(row).replace(/"/g, '').split(' -- ').map(value => value.trim())) : [];
      let tables;
      if (rows.length > 1 && rows.every(row => row.length > 1)) tables = [rows];
      else {
        const handle = slide.dataset.productHandle;
        if (!this.sizeCharts.has(handle)) {
          const root = window.Shopify?.routes?.root || '/';
          this.sizeCharts.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
            .then(response => { if (!response.ok) throw new Error('Size chart request failed'); return response.json(); })
            .then(product => {
              // Parse inert merchant content, then copy only cell text into our own tables.
              const template = document.createElement('template'); template.innerHTML = product.description || '';
              return [...template.content.querySelectorAll('table.gridtable,table[id="zh-size-table"]')]
                .map(table => [...table.rows].map(row => [...row.cells].map(cell => cell.querySelector('[data-size]')?.dataset.size || cell.textContent.trim())))
                .filter(table => table.length > 1 && table[0].length > 1);
            }).catch(error => { this.sizeCharts.delete(handle); throw error; }));
        }
        tables = await this.sizeCharts.get(handle);
      }
      if (request !== this.sizeRequest || !dialog.open) return;
      this.sizeTables = tables;
      if (!tables.length) {
        dialog.querySelector('[data-size-status]').textContent = 'No size chart is available for this product yet.';
        return;
      }
      dialog.querySelector('[data-size-units]').hidden = false;
      this.renderSizeTables('cm');
      this.event('reels_size_chart_open');
    } catch (error) {
      if (request !== this.sizeRequest || !dialog.open) return;
      dialog.querySelector('[data-size-status]').textContent = 'Unable to load the size chart. Please try again.';
      dialog.querySelector('[data-size-retry]').hidden = false;
    }
  }
  renderSizeTables(unit) {
    const dialog = this.sizeDialog, container = dialog.querySelector('[data-size-tables]');
    container.replaceChildren();
    dialog.querySelectorAll('[data-size-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizeUnit === unit)));
    dialog.querySelector('[data-size-status]').hidden = false;
    dialog.querySelector('[data-size-status]').textContent = 'Swipe the table to see all columns.';
    dialog.querySelector('[data-size-note]').hidden = false;
    this.sizeTables.forEach(rows => {
      const table = document.createElement('table');
      rows.forEach((values, rowIndex) => {
        const row = table.insertRow();
        values.forEach((value, columnIndex) => {
          const cell = document.createElement(rowIndex === 0 || columnIndex === 0 ? 'th' : 'td');
          if (cell.tagName === 'TH') cell.scope = rowIndex === 0 ? 'col' : 'row';
          let text = value;
          // Convert only measurements, never size labels or nonnumeric notes.
          if (unit === 'inch' && rowIndex > 0 && columnIndex > 0 && /^\d+(\.\d+)?(\s*[-/\u2013~]\s*\d+(\.\d+)?)*$/.test(value)) {
            text = value.replace(/\d+(\.\d+)?/g, number => (Number(number) / 2.54).toFixed(2));
          }
          cell.textContent = rowIndex === 0 && columnIndex === 0 && !text ? 'Size' : text;
          row.append(cell);
        });
      });
      container.append(table);
    });
  }
  closeSizeChart(focus = true) {
    this.sizeRequest = (this.sizeRequest || 0) + 1;
    if (!this.sizeDialog?.open) return;
    this.sizeDialog.close();
    if (focus) this.sizeTrigger?.focus({ preventScroll: true });
  }
  updateVariant(sheet) {
    sheet.querySelectorAll('[data-reels-option]').forEach(group => {
      const label = group.querySelector('[data-reels-option-label]');
      if (label) label.textContent = group.querySelector('.is-selected')?.dataset.value || '';
      group.querySelectorAll('[data-reels-option-value]').forEach(button =>
        button.setAttribute('aria-pressed', String(button.classList.contains('is-selected'))));
    });
    const selected = [...sheet.querySelectorAll('[data-reels-option]')].map(group => group.querySelector('.is-selected')?.dataset.value);
    const variant = sheet._variants?.find(item => item.options.every((value, index) => value === selected[index]));
    const add = sheet.querySelector('[data-reels-add]');
    if (!variant) { add.disabled = true; add.textContent = 'Unavailable'; return; }
    add.dataset.variantId = variant.id; add.disabled = !variant.available; add.textContent = variant.available ? '＋ Add to cart' : 'Sold out';
    // Liquid formats every variant in the active Shopify market's currency.
    const price = sheet._prices?.[String(variant.id)];
    if (price) sheet.querySelector('[data-reels-sheet-price]').textContent = price;
  }
  async addToCart(button) {
    const sheet = button.closest('[data-reels-product-sheet]'), message = sheet.querySelector('[data-reels-sheet-message]');
    const slide = button.closest('[data-reel]'), variantId = Number(button.dataset.variantId);
    const attribution = this.eventDetail(slide);
    const properties = { _reels_video: attribution.reel_id, _reels_product: attribution.product_id, _reels_label: attribution.reel_label, _reels_environment: attribution.reels_environment };
    if (attribution.product_spu) properties._reels_spu = attribution.product_spu;
    if (attribution.reel_filename) properties._reels_filename = attribution.reel_filename;
    button.disabled = true; button.classList.add('is-loading'); message.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] }) });
      const data = await response.json(); if (!response.ok) throw new Error(data.description || data.message || 'Unable to add to cart');
      message.textContent = 'Added to cart'; button.textContent = 'Added ✓';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      this.event('reels_add_to_cart', { ...attribution, variant_id: String(variantId), quantity: 1 });
      setTimeout(() => { sheet.hidden = true; }, 700);
    } catch (error) { message.textContent = error.message; button.disabled = false; }
    finally { button.classList.remove('is-loading'); }
  }
  eventDetail(slide = this.s[this.i]) {
    return { tracking_version: '2', reels_environment: window.Shopify?.theme?.role === 'main' && !window.Shopify?.designMode ? 'production' : 'preview', reel_id: slide?.dataset.reelId || '', reel_filename: this.videoFilename(slide), reel_index: this.s.indexOf(slide) + 1, reel_label: (slide?.dataset.spu || '').slice(0, 100), product_id: slide?.dataset.productId || '', product_spu: this.productSpu(slide), product_handle: slide?.dataset.productHandle || '', currency: slide?.dataset.currency || '' };
  }
  videoFilename(slide) {
    if (!slide) return '';
    // Read on each event so the theme editor can replace the mapping with the section.
    try {
      const names = JSON.parse(this.querySelector('[data-reels-filenames]')?.textContent || '{}');
      const name = names[slide.dataset.videoId] || slide.dataset.reelFilename || '';
      return typeof name === 'string' ? Array.from(name).slice(0, 100).join('') : '';
    } catch (_) { return ''; }
  }
  productSpu(slide) {
    if (!slide) return '';
    if (slide.dataset.productSpu !== undefined) return slide.dataset.productSpu;
    let spu = '';
    try {
      const variants = JSON.parse(slide.querySelector('[data-reels-variants]')?.textContent || '[]');
      const codes = variants.map(variant => /^CY-!(\d+)(?:-|$)/.exec(variant.sku || '')?.[1] || '');
      if (codes.length && codes[0] && codes.every(code => code === codes[0])) spu = codes[0];
    } catch (_) { /* Unknown SKU format: do not guess a product code. */ }
    slide.dataset.productSpu = spu;
    return spu;
  }
  event(name, extra = {}) {
    const detail = { ...this.eventDetail(name === 'reels_button_click' ? null : undefined), ...extra };
    // One delivery route; pixel consent and GA forwarding are handled by Shopify.
    // Analytics failures must never interrupt playback or a successful cart add.
    try {
      const pending = window.Shopify?.analytics?.publish?.(name, detail);
      pending?.catch?.(() => {});
    } catch (_) { /* Pixel unavailable: storefront remains usable. */ }
    document.dispatchEvent(new CustomEvent(`uoozee:${name}`, { detail }));
  }
});
